export default __webpack_public_path__ + "static/media/kwanzaa-appbar-tile.1b32e646.png";